const byValue = function (value, collection) {
  if (collection && collection.length > 0) {
    for (let ndx = 0; ndx < collection.length; ndx++) {
      let item = collection[ndx];
      if (item.value && item.value === value) {
        return item;
      }
    }
  }

  return null;
};

const tiposDocumento = [
  {
    value: "DNI",
    label: "DNI"
  },
  {
    value: "01",
    label: "LE"
  },
  {
    value: "02",
    label: "LC"
  }
];

const estadosCiviles = [
  {
    value: "1",
    label: "Casado/a"
  },
  {
    value: "2",
    label: "Viudo/a"
  },
  {
    value: "3",
    label: "Separado/a"
  },
  {
    value: "4",
    label: "Divorciado/a"
  },
  {
    value: "5",
    label: "Soltero/a"
  },
  {
    value: "6",
    label: "Concubinato"
  }
];

const provincias = [
  { value: "01", label: "CAPITAL FEDERAL" },
  { value: "02", label: "BUENOS AIRES" },
  { value: "03", label: "CATAMARCA" },
  { value: "04", label: "CORDOBA" },
  { value: "05", label: "CORRIENTES" },
  { value: "06", label: "CHACO" },
  { value: "07", label: "CHUBUT" },
  { value: "08", label: "ENTRE RIOS" },
  { value: "09", label: "FORMOSA" },
  { value: "10", label: "JUJUY" },
  { value: "11", label: "LA PAMPA" },
  { value: "12", label: "LA RIOJA" },
  { value: "13", label: "MENDOZA" },
  { value: "14", label: "MISIONES" },
  { value: "15", label: "NEUQUEN" },
  { value: "16", label: "RIO NEGRO" },
  { value: "17", label: "SALTA" },
  { value: "18", label: "SAN JUAN" },
  { value: "19", label: "SAN LUIS" },
  { value: "20", label: "SANTA CRUZ" },
  { value: "21", label: "SANTA FE" },
  { value: "22", label: "SANTIAGO DEL ESTERO" },
  { value: "40", label: "TIERRA DEL FUEGO" },
  { value: "23", label: "TUCUMAN" }
];

const situacionesLaborales = [
  {
    value: "001",
    oldValue: "0",
    label: "En rel. de dependencia"
  },
  {
    value: "002",
    oldValue: "1",
    label: "Contratado"
  },
  {
    value: "003",
    oldValue: "3",
    label: "Autónomo"
  },
  {
    value: "004",
    oldValue: "2",
    label: "Otro"
  }
];

const actividades = [
  {
    label: "ADMIN. PUBLICA",
    value: "24"
  },
  {
    label: "AGENCIA VIAJES,ALQUILER AUTO",
    value: "45"
  },
  {
    label: "AGRICULTURA",
    value: "01"
  },
  {
    label: "ALIMENTACION/TABACO",
    value: "14"
  },
  {
    label: "ALQUILER/VENTA INMUEBLES",
    value: "38"
  },
  {
    label: "ASESORIA,INGENIERIA,SERVICIOS",
    value: "32"
  },
  {
    label: "BANCA PRIVADA/FINAN/SEG.",
    value: "29"
  },
  {
    label: "BANCA PUBLICA/FINAN/SEG.",
    value: "30"
  },
  {
    label: "BEBIDAS",
    value: "15"
  },
  {
    label: "CAZA/SILVICULTURA",
    value: "02"
  },
  {
    label: "COMERCIO MAYORISTA",
    value: "34"
  },
  {
    label: "COMERCIO MINORISTA",
    value: "35"
  },
  {
    label: "CONSTRUCCCION Y MATERIALES CONS",
    value: "13"
  },
  {
    label: "CORREOS Y TELECOMUNICACIONES",
    value: "46"
  },
  {
    label: "CUERO/PIEL/CALZADO",
    value: "17"
  },
  {
    label: "DIPLOMATICOS-ORG.INTERNACIONALES",
    value: "26"
  },
  {
    label: "ELECTRICIDAD,ELECTRODOMESTICOS",
    value: "10"
  },
  {
    label: "ELECTRONICA,INFORMATICA ETC",
    value: "11"
  },
  {
    label: "ENERGIA,AGUA,GAS",
    value: "07"
  },
  {
    label: "ENSENANZA PRIVADA",
    value: "28"
  },
  {
    label: "ESPECTACULOS/DEPORTES",
    value: "40"
  },
  {
    label: "EXPLOT.MINAS/CANTERAS",
    value: "06"
  },
  {
    label: "EXPLOTACION Y SERV.AGROPECUARIOS",
    value: "03"
  },
  {
    label: "FAB VEHICULOS Y AUTOPARTES",
    value: "12"
  },
  {
    label: "FERROCARRIL",
    value: "44"
  },
  {
    label: "GANADERIA",
    value: "04"
  },
  {
    label: "HOTELERIA,RESTAURANTE",
    value: "36"
  },
  {
    label: "MADERA,CERAMICA,VIDRIO",
    value: "18"
  },
  {
    label: "MAQUINARIA,INGEN/MECANICA",
    value: "09"
  },
  {
    label: "METAL/SIDERURGIA",
    value: "08"
  },
  {
    label: "MILITAR-POLICIA",
    value: "25"
  },
  {
    label: "MUEBLES,JUGUETES Y ART.DEPORTIVOS",
    value: "19"
  },
  {
    label: "PAPEL/ARTES GRAFICAS",
    value: "20"
  },
  {
    label: "PESCA",
    value: "05"
  },
  {
    label: "PETROLEO",
    value: "22"
  },
  {
    label: "PRENSA/RADIO/TV",
    value: "39"
  },
  {
    label: "PRODUCTOS QUIMICOS/FARMACIA",
    value: "21"
  },
  {
    label: "REPARACION VEHICULOS/AUXILIO MECANICO",
    value: "37"
  },
  {
    label: "SALUD PRIVADA/VETERINARIA",
    value: "49"
  },
  {
    label: "SANIDAD,SERV.PUB/VETERINARIA",
    value: "27"
  },
  {
    label: "SEGURIDAD",
    value: "48"
  },
  {
    label: "SERV.DOMESTICOS Y PERSON.",
    value: "33"
  },
  {
    label: "SERV.INFORMATICOS,SOFTWARE",
    value: "31"
  },
  {
    label: "TEXTIL Y VESTIDO",
    value: "16"
  },
  {
    label: "TRANSPORTE AEREO",
    value: "42"
  },
  {
    label: "TRANSPORTE NAVAL",
    value: "43"
  },
  {
    label: "TRANSPORTE TERRESTRE",
    value: "41"
  },
  {
    label: "OTRAS INDUSTRIAS",
    value: "23"
  },
  {
    label: "OTROS SERVICIOS",
    value: "47"
  }
];

const ocupaciones = [
  {
    situacionLaboral: "003",
    label: "ABOGADO",
    value: "18"
  },
  {
    situacionLaboral: "003",
    label: "ACTIVIDADES AGROPECUARIAS",
    value: "28"
  },
  {
    situacionLaboral: "001",
    label: "ADMINISTRATIVO",
    value: "07"
  },
  {
    situacionLaboral: "001",
    label: "ALTOS FUNCIONARIOS PUBLICOS/DIPLOMATICOS",
    value: "06"
  },
  {
    situacionLaboral: "003",
    label: "ARQUITECTO/INGENIERO",
    value: "20"
  },
  {
    situacionLaboral: "003",
    label: "ARTISTA/DEPORTISTA PROFESIONAL",
    value: "24"
  },
  {
    situacionLaboral: "003",
    label: "ASESOR/CONSULTOR/AUDITOR/COMPUTACION",
    value: "29"
  },
  {
    situacionLaboral: "003",
    label: "BIOLOGO/CIENCIAS EXACTAS",
    value: "30"
  },
  {
    situacionLaboral: "003",
    label: "COMERCIANTE/EMPRESARIO/INDUSTRIAL",
    value: "25"
  },
  {
    situacionLaboral: "003",
    label: "CONTADOR/ECONOMISTA/ADMINISTRADOR",
    value: "26"
  },
  {
    situacionLaboral: "001",
    label: "DIPLOMATICOS ARGENTINOS",
    value: "46"
  },
  {
    situacionLaboral: "001",
    label: "DIPLOMATICOS EXTRANJEROS",
    value: "47"
  },
  {
    situacionLaboral: "001",
    label: "DOCENTE",
    value: "11"
  },
  {
    situacionLaboral: "001",
    label: "EMPLEADO PUBLICO(NO VIA PUBLICA NI SEGURIDAD)",
    value: "41"
  },
  {
    situacionLaboral: "001",
    label: "ENCARGADO",
    value: "12"
  },
  {
    situacionLaboral: "003",
    label: "ESCRIBANO/NOTARIO",
    value: "19"
  },
  {
    situacionLaboral: "003",
    label: "ESCRITOR/TRADUCTOR",
    value: "21"
  },
  {
    situacionLaboral: "003",
    label: "FARMACEUTICO",
    value: "23"
  },
  {
    situacionLaboral: "001",
    label: "GERENTE DE AREA/SUPERVISOR/TESORERO",
    value: "03"
  },
  {
    situacionLaboral: "001",
    label: "JEFE/MANDO INTERMEDIO/ADMINISTRADOR",
    value: "04"
  },
  {
    situacionLaboral: "001",
    label: "JUEZ/FISCAL/CATEDRATICO",
    value: "10"
  },
  {
    situacionLaboral: "001",
    label: "MEDICO ASALARIADO",
    value: "40"
  },
  {
    situacionLaboral: "003",
    label: "MEDICO/ODONTOLOGO",
    value: "17"
  },
  {
    situacionLaboral: "001",
    label: "MILITAR/POLICIA(OFICIAL/RANGOS SUPERIORES)",
    value: "08"
  },
  {
    situacionLaboral: "001",
    label: "MILITAR/POLICIA(RANGOS INFERIORES)",
    value: "09"
  },
  {
    situacionLaboral: "001",
    label: "OBRERO / OPERARIO",
    value: "14"
  },
  {
    situacionLaboral: "001",
    label: "OBRERO CALIFICADO / OPERARIO CALIFICADO",
    value: "13"
  },
  {
    situacionLaboral: "003",
    label: "OFICIOS:ELECTRICISTA,PLOMERO,ETC",
    value: "27"
  },
  {
    situacionLaboral: "001",
    label: "PERIODISTA",
    value: "45"
  },
  {
    situacionLaboral: "003",
    label: "PERIODISTA/ESCRITOR/GUIONISTA",
    value: "43"
  },
  {
    situacionLaboral: "003",
    label: "POLITICO",
    value: "42"
  },
  {
    situacionLaboral: "001",
    label: "PRESIDENTE/GERENTE GRAL/GERENTE EJECUTIVO",
    value: "01"
  },
  {
    situacionLaboral: "001",
    label: "PROFESIONAL TECNICO",
    value: "05"
  },
  {
    situacionLaboral: "003",
    label: "PSICOLOGO",
    value: "44"
  },
  {
    situacionLaboral: "001",
    label: "SEGURIDAD/INVESTIGACION/DETECTIVE",
    value: "37"
  },
  {
    situacionLaboral: "001",
    label: "VENDEDOR (NO EN VIA PUBLICA)",
    value: "15"
  },
  {
    situacionLaboral: "003",
    label: "VETERINARIO",
    value: "22"
  },
  {
    situacionLaboral: "001",
    label: "VICEPRESIDENTE/DIRECTOR/SOCIO",
    value: "02"
  },
  {
    situacionLaboral: "001",
    label: "OTROS ASALARIADOS",
    value: "16"
  },
  {
    situacionLaboral: "003",
    label: "OTROS INDEPENDIENTES",
    value: "31"
  }
];

const ingresosNetos = [
  {
    value: "4500",
    label: "Menos de $10.000"
  },
  {
    value: "10001",
    label: "$10.000 - $15.000"
  },
  {
    value: "15001",
    label: "$15.000 - $25.000"
  },
  {
    value: "+25001",
    label: "Más de $25.000"
  }
];

const sucursales = [
  {
    numero: "0001",
    provincia: "CAPITAL FEDERAL",
    localidad: "PARQUE CHACABUCO",
    label: "ASAMBLEA",
    direccion: "AV. ASAMBLEA 695",
    value: "0001"
  },
  {
    numero: "0003",
    provincia: "CAPITAL FEDERAL",
    localidad: "BOCA",
    label: "BOCA",
    direccion: "AV. ALMIRANTE BROWN 826",
    value: "0003"
  },
  {
    numero: "0004",
    provincia: "CAPITAL FEDERAL",
    localidad: "BOEDO",
    label: "BOEDO",
    direccion: "AV. SAN JUAN 3599",
    value: "0004"
  },
  {
    numero: "0005",
    provincia: "CAPITAL FEDERAL",
    localidad: "SAN NICOLAS",
    label: "OBELISCO",
    direccion: "AV. CORRIENTES 1102",
    value: "0005"
  },
  {
    numero: "0006",
    provincia: "CAPITAL FEDERAL",
    localidad: "CONSTITUCION",
    label: "CONSTITUCION",
    direccion: "BERNARDO DE IRIGOYEN 1600",
    value: "0006"
  },
  {
    numero: "0008",
    provincia: "GRAN BUENOS AIRES",
    localidad: "MORON",
    label: "MORON UNIVERSIDAD",
    direccion: "MACHADO 815",
    value: "0008"
  },
  {
    numero: "0011",
    provincia: "GRAN BUENOS AIRES",
    localidad: "MERCEDES",
    label: "MERCEDES",
    direccion: "AV. 29 NRO 493",
    value: "0011"
  },
  {
    numero: "0013",
    provincia: "GRAN BUENOS AIRES",
    localidad: "SAN FERNANDO",
    label: "SAN FERNANDO",
    direccion: "CONSTITUCION 1",
    value: "0013"
  },
  {
    numero: "0014",
    provincia: "GRAN BUENOS AIRES",
    localidad: "SAN JUSTO",
    label: "SAN JUSTO",
    direccion: "VILLEGAS 2429",
    value: "0014"
  },
  {
    numero: "0015",
    provincia: "GRAN BUENOS AIRES",
    localidad: "SAN MARTIN",
    label: "SAN MARTIN",
    direccion: "CALLE 91 NRO 2160-68",
    value: "0015"
  },
  {
    numero: "0018",
    provincia: "GRAN BUENOS AIRES",
    localidad: "VILLA LYNCH",
    label: "VILLA LYNCH",
    direccion: "REPUBLICA DEL LIBANO 247",
    value: "0018"
  },
  {
    numero: "0007",
    provincia: "CAPITAL FEDERAL",
    localidad: "ABASTO",
    label: "ABASTO",
    direccion: "AV. CORRIENTES 3399 ESQ. GALLO",
    value: "0007"
  },
  {
    numero: "0010",
    provincia: "CAPITAL FEDERAL",
    localidad: "NUEVA POMPEYA",
    label: "NUEVA POMPEYA",
    direccion: "AV. SAENZ 1146",
    value: "0010"
  },
  {
    numero: "0012",
    provincia: "CAPITAL FEDERAL",
    localidad: "PARQUE PATRICIOS",
    label: "PATRICIOS",
    direccion: "RONDEAU 3002",
    value: "0012"
  },
  {
    numero: "0016",
    provincia: "CAPITAL FEDERAL",
    localidad: "BELGRANO",
    label: "BELGRANO C",
    direccion: "AV. DEL LIBERTADOR 6220",
    value: "0016"
  },
  {
    numero: "0017",
    provincia: "CAPITAL FEDERAL",
    localidad: "RECOLETA",
    label: "BARRIO NORTE",
    direccion: "AV. SANTA FE 1630",
    value: "0017"
  },
  {
    numero: "0023",
    provincia: "CAPITAL FEDERAL",
    localidad: "RECOLETA",
    label: "RECOLETA",
    direccion: "AV. CALLAO 1499",
    value: "0023"
  },
  {
    numero: "0025",
    provincia: "CAPITAL FEDERAL",
    localidad: "FLORESTA",
    label: "FLORESTA",
    direccion: "AV. J.B.JUSTO 7132",
    value: "0025"
  },
  {
    numero: "0019",
    provincia: "GRAN BUENOS AIRES",
    localidad: "VILLA DOMINICO",
    label: "VILLA DOMINICO",
    direccion: "AV. MITRE 4165/69",
    value: "0019"
  },
  {
    numero: "0026",
    provincia: "CAPITAL FEDERAL",
    localidad: "PALERMO",
    label: "PALERMO",
    direccion: "AV. SANTA FE 5000",
    value: "0026"
  },
  {
    numero: "0032",
    provincia: "CAPITAL FEDERAL",
    localidad: "BARRACAS",
    label: "MONTES DE OCA",
    direccion: "AV. MONTES DE OCA 1107",
    value: "0032"
  },
  {
    numero: "0035",
    provincia: "CAPITAL FEDERAL",
    localidad: "VILLA CRESPO",
    label: "VILLA CRESPO",
    direccion: "AV. CORDOBA 4675/77",
    value: "0035"
  },
  {
    numero: "0038",
    provincia: "CAPITAL FEDERAL",
    localidad: "PATERNAL",
    label: "PATERNAL",
    direccion: "AV. SAN MARTIN 2349",
    value: "0038"
  },
  {
    numero: "0039",
    provincia: "CAPITAL FEDERAL",
    localidad: "SAN NICOLAS",
    label: "PLAZA ROMA",
    direccion: "TUCUMAN 101",
    value: "0039"
  },
  {
    numero: "0020",
    provincia: "GRAN BUENOS AIRES",
    localidad: "LLAVALLOL",
    label: "LLAVALLOL",
    direccion: "AV.ANTARTIDA ARG.1770/76",
    value: "0020"
  },
  {
    numero: "0042",
    provincia: "CAPITAL FEDERAL",
    localidad: "VILLA GENERAL MITRE",
    label: "NAZCA",
    direccion: "AV. NAZCA 1922",
    value: "0042"
  },
  {
    numero: "0022",
    provincia: "GRAN BUENOS AIRES",
    localidad: "LOMAS DEL MIRADOR",
    label: "LOMAS DEL MIRADOR",
    direccion: "AV. MOSCONI 1149",
    value: "0022"
  },
  {
    numero: "0027",
    provincia: "GRAN BUENOS AIRES",
    localidad: "LANUS",
    label: "LANUS ESTE",
    direccion: "AV. 9 DE JULIO 2090",
    value: "0027"
  },
  {
    numero: "0028",
    provincia: "GRAN BUENOS AIRES",
    localidad: "BERNAL",
    label: "BERNAL",
    direccion: "AV.CRISOLOGO LARRALDE 800",
    value: "0028"
  },
  {
    numero: "0030",
    provincia: "GRAN BUENOS AIRES",
    localidad: "GERLI",
    label: "GERLI",
    direccion: "LACARRA 1585",
    value: "0030"
  },
  {
    numero: "0043",
    provincia: "CAPITAL FEDERAL",
    localidad: "MONSERRAT",
    label: "AV. ENTRE RIOS",
    direccion: "AV. ENTRE RIOS 466/70",
    value: "0043"
  },
  {
    numero: "0037",
    provincia: "GRAN BUENOS AIRES",
    localidad: "VILLA ADELINA",
    label: "VILLA ADELINA",
    direccion: "PARANA 6552",
    value: "0037"
  },
  {
    numero: "0044",
    provincia: "CAPITAL FEDERAL",
    localidad: "MONSERRAT",
    label: "PIEDRAS",
    direccion: "AV. DE MAYO 782",
    value: "0044"
  },
  {
    numero: "0051",
    provincia: "CAPITAL FEDERAL",
    localidad: "CAPITAL FEDERAL",
    label: "ARROYO",
    direccion: "CARLOS PELLEGRINI 1413",
    value: "0051"
  },
  {
    numero: "0052",
    provincia: "CAPITAL FEDERAL",
    localidad: "CAPITAL FEDERAL",
    label: "LE PARC",
    direccion: "AV. CERVINO 4648",
    value: "0052"
  },
  {
    numero: "0058",
    provincia: "GRAN BUENOS AIRES",
    localidad: "MERLO",
    label: "MERLO",
    direccion: "AV. LIBERTADOR 323",
    value: "0058"
  },
  {
    numero: "0061",
    provincia: "SANTA CRUZ",
    localidad: "CIUDAD DE LAS HERAS",
    label: "LAS HERAS",
    direccion: "PERITO MORENO 348",
    value: "0061"
  },
  {
    numero: "0062",
    provincia: "GRAN BUENOS AIRES",
    localidad: "Chascomus",
    label: "CHASCOMUS",
    direccion: "LIBRES DEL SUR NRO: 112",
    value: "0062"
  },
  {
    numero: "0056",
    provincia: "CAPITAL FEDERAL",
    localidad: "BOCA",
    label: "MARTIN GARCIA",
    direccion: "AV. MARTIN GARCIA 702",
    value: "0056"
  },
  {
    numero: "0099",
    provincia: "CAPITAL FEDERAL",
    localidad: "SAN NICOLAS",
    label: "CENTRO",
    direccion: "RECONQUISTA 199",
    value: "0099"
  },
  {
    numero: "0101",
    provincia: "CAPITAL FEDERAL",
    localidad: "BELGRANO",
    label: "AV. CABILDO",
    direccion: "AV. CABILDO 1732/40",
    value: "0101"
  },
  {
    numero: "0065",
    provincia: "MISIONES",
    localidad: "OBERA",
    label: "OBERA",
    direccion: "AV. SARMIENTO 950",
    value: "0065"
  },
  {
    numero: "0105",
    provincia: "CAPITAL FEDERAL",
    localidad: "VILLA DEL PARQUE",
    label: "VILLA DEL PARQUE",
    direccion: "NOGOYA 3256",
    value: "0105"
  },
  {
    numero: "0066",
    provincia: "SANTA FE",
    localidad: "ROSARIO",
    label: "FISHERTON",
    direccion: "AV. EVA PERON 7461",
    value: "0066"
  },
  {
    numero: "0106",
    provincia: "CAPITAL FEDERAL",
    localidad: "ALMAGRO",
    label: "PARQUE CENTENARIO",
    direccion: "AV. CORRIENTES 4694",
    value: "0106"
  },
  {
    numero: "0068",
    provincia: "ENTRE RIOS",
    localidad: "CONCORDIA",
    label: "CONCORDIA",
    direccion: "ENTRE RIOS 640",
    value: "0068"
  },
  {
    numero: "0070",
    provincia: "TUCUMAN",
    localidad: "S.M.DE TUCUMAN",
    label: "TUCUMAN NORTE",
    direccion: "SANTA FE 596",
    value: "0070"
  },
  {
    numero: "0107",
    provincia: "CAPITAL FEDERAL",
    localidad: "VILLA LURO",
    label: "MONTE CASTRO",
    direccion: "ALVAREZ JONTE 5255",
    value: "0107"
  },
  {
    numero: "0071",
    provincia: "SANTIAGO DEL ESTERO",
    localidad: "SGO.DEL ESTERO",
    label: "SANTIAGO DEL ESTERO",
    direccion: "24 DE SETIEMBRE 199",
    value: "0071"
  },
  {
    numero: "0072",
    provincia: "SAN JUAN",
    localidad: "SAN JUAN",
    label: "SAN JUAN",
    direccion: "RIVADAVIA 56",
    value: "0072"
  },
  {
    numero: "0074",
    provincia: "ENTRE RIOS",
    localidad: "PARANA",
    label: "PARANA",
    direccion: "SAN MARTIN 763",
    value: "0074"
  },
  {
    numero: "0108",
    provincia: "CAPITAL FEDERAL",
    localidad: "PALERMO",
    label: "CORONEL DIAZ",
    direccion: "AV. CORONEL DIAZ 2257",
    value: "0108"
  },
  {
    numero: "0111",
    provincia: "CAPITAL FEDERAL",
    localidad: "ONCE",
    label: "ONCE",
    direccion: "AV. CORRIENTES 2243",
    value: "0111"
  },
  {
    numero: "0075",
    provincia: "ENTRE RIOS",
    localidad: "GUALEGUAYCHU",
    label: "GUALEGUAYCHU",
    direccion: "25 DE MAYO 944",
    value: "0075"
  },
  {
    numero: "0114",
    provincia: "CAPITAL FEDERAL",
    localidad: "DEVOTO",
    label: "AVENIDA BEIRO",
    direccion: "AV. FCO. BEIRO 4359/61",
    value: "0114"
  },
  {
    numero: "0116",
    provincia: "CAPITAL FEDERAL",
    localidad: "RETIRO",
    label: "CANCILLERIA",
    direccion: "AV. SANTA FE 946",
    value: "0116"
  },
  {
    numero: "0076",
    provincia: "CORRIENTES",
    localidad: "PASO DE LOS LIBRES",
    label: "PASO DE LOS LIBRES",
    direccion: "COLON 794",
    value: "0076"
  },
  {
    numero: "0077",
    provincia: "GRAN BUENOS AIRES",
    localidad: "TANDIL",
    label: "TANDIL",
    direccion: "PINTO 771",
    value: "0077"
  },
  {
    numero: "0078",
    provincia: "GRAN BUENOS AIRES",
    localidad: "SAN PEDRO",
    label: "SAN PEDRO",
    direccion: "BARTOLOME MITRE 955",
    value: "0078"
  },
  {
    numero: "0079",
    provincia: "GRAN BUENOS AIRES",
    localidad: "SAN NICOLAS",
    label: "SAN NICOLAS",
    direccion: "BARTOLOME MITRE 215/7",
    value: "0079"
  },
  {
    numero: "0080",
    provincia: "GRAN BUENOS AIRES",
    localidad: "BAHIA BLANCA",
    label: "BAHIA BLANCA",
    direccion: "CHICLANA 63",
    value: "0080"
  },
  {
    numero: "0081",
    provincia: "SANTA FE",
    localidad: "ROSARIO",
    label: "ROSARIO",
    direccion: "CORDOBA 1039 ESQ. SARMIENTO",
    value: "0081"
  },
  {
    numero: "0117",
    provincia: "CAPITAL FEDERAL",
    localidad: "ALMAGRO",
    label: "CASTRO BARROS",
    direccion: "AV. RIVADAVIA 4059",
    value: "0117"
  },
  {
    numero: "0082",
    provincia: "GRAN BUENOS AIRES",
    localidad: "CHIVILCOY",
    label: "CHIVILCOY",
    direccion: "CARLOS PELLEGRINI 102",
    value: "0082"
  },
  {
    numero: "0083",
    provincia: "RIO NEGRO",
    localidad: "GRAL.ROCA",
    label: "GENERAL ROCA",
    direccion: "TUCUMAN 699",
    value: "0083"
  },
  {
    numero: "0084",
    provincia: "CORDOBA",
    localidad: "CORDOBA",
    label: "CORDOBA",
    direccion: "25 DE MAYO 280",
    value: "0084"
  },
  {
    numero: "0085",
    provincia: "MENDOZA",
    localidad: "MENDOZA",
    label: "MENDOZA",
    direccion: "SAN MARTIN 936",
    value: "0085"
  },
  {
    numero: "0118",
    provincia: "CAPITAL FEDERAL",
    localidad: "SAN TELMO",
    label: "SAN TELMO 1",
    direccion: "PASEO COLON 505",
    value: "0118"
  },
  {
    numero: "0120",
    provincia: "CAPITAL FEDERAL",
    localidad: "VILLA URQUIZA",
    label: "VILLA URQUIZA",
    direccion: "AV. TRIUNVIRATO 5201",
    value: "0120"
  },
  {
    numero: "0087",
    provincia: "SALTA",
    localidad: "SALTA",
    label: "SALTA",
    direccion: "ESPANA 642",
    value: "0087"
  },
  {
    numero: "0089",
    provincia: "NEUQUEN",
    localidad: "NEUQUEN",
    label: "NEUQUEN",
    direccion: "CARLOS RODRIGUEZ 48",
    value: "0089"
  },
  {
    numero: "0123",
    provincia: "CAPITAL FEDERAL",
    localidad: "PUERTO MADERO",
    label: "PUERTO MADERO",
    direccion: "A.M. DE JUSTO 868",
    value: "0123"
  },
  {
    numero: "0124",
    provincia: "CAPITAL FEDERAL",
    localidad: "CABALLITO",
    label: "CABALLITO",
    direccion: "AV. RIVADAVIA 5300",
    value: "0124"
  },
  {
    numero: "0090",
    provincia: "GRAN BUENOS AIRES",
    localidad: "MAR DEL PLATA",
    label: "MAR DEL PLATA -INDEPEND",
    direccion: "INDEPENDENCIA 2650",
    value: "0090"
  },
  {
    numero: "0091",
    provincia: "GRAN BUENOS AIRES",
    localidad: "PERGAMINO",
    label: "PERGAMINO",
    direccion: "SAN NICOLAS 649",
    value: "0091"
  },
  {
    numero: "0093",
    provincia: "GRAN BUENOS AIRES",
    localidad: "LA PLATA",
    label: "LA PLATA",
    direccion: "CALLE 47 NRO 641",
    value: "0093"
  },
  {
    numero: "0094",
    provincia: "GRAN BUENOS AIRES",
    localidad: "MAR DEL PLATA",
    label: "MAR DEL PLATA-CENTRO",
    direccion: "AV. LURO 3157 ESQ. CATAMARCA",
    value: "0094"
  },
  {
    numero: "0097",
    provincia: "CHUBUT",
    localidad: "COMODORO RIVADAVIA",
    label: "COMODORO RIVADAVIA",
    direccion: "SAN MARTIN 302",
    value: "0097"
  },
  {
    numero: "0109",
    provincia: "GRAN BUENOS AIRES",
    localidad: "QUILMES",
    label: "QUILMES",
    direccion: "ALSINA 216",
    value: "0109"
  },
  {
    numero: "0110",
    provincia: "GRAN BUENOS AIRES",
    localidad: "LA PLATA",
    label: "CALLE 12",
    direccion: "CALLE 12 NRO 1081",
    value: "0110"
  },
  {
    numero: "0126",
    provincia: "CAPITAL FEDERAL",
    localidad: "FLORES",
    label: "FLORES",
    direccion: "AV. RIVADAVIA 6483/87",
    value: "0126"
  },
  {
    numero: "0135",
    provincia: "CAPITAL FEDERAL",
    localidad: "CABALLITO",
    label: "SCALABRINI ORTIZ",
    direccion: "AV. CORRIENTES 5117",
    value: "0135"
  },
  {
    numero: "0137",
    provincia: "CAPITAL FEDERAL",
    localidad: "VILLA LUGANO",
    label: "VILLA LUGANO",
    direccion: "SAYOS 5717",
    value: "0137"
  },
  {
    numero: "0113",
    provincia: "GRAN BUENOS AIRES",
    localidad: "GENERAL PACHECO",
    label: "TALAR DE PACHECO",
    direccion: "HIPOLITO YRIGOYEN 921",
    value: "0113"
  },
  {
    numero: "0141",
    provincia: "CAPITAL FEDERAL",
    localidad: "CAPITAL FEDERAL",
    label: "PUERTO MADERO ESTE",
    direccion: "JUANA MANSO 1124 PB",
    value: "0141"
  },
  {
    numero: "0119",
    provincia: "ENTRE RIOS",
    localidad: "COLON",
    label: "COLON",
    direccion: "12 DE ABRIL 342/350",
    value: "0119"
  },
  {
    numero: "0121",
    provincia: "GRAN BUENOS AIRES",
    localidad: "MUNRO",
    label: "MUNRO",
    direccion: "AV. VELEZ SARFIELD 5250",
    value: "0121"
  },
  {
    numero: "0128",
    provincia: "GRAN BUENOS AIRES",
    localidad: "LA PLATA",
    label: "LA PLATA NORTE",
    direccion: "CALLE 7 NRO. 21",
    value: "0128"
  },
  {
    numero: "0130",
    provincia: "GRAN BUENOS AIRES",
    localidad: "MORENO",
    label: "MORENO",
    direccion: "ESPANA 203",
    value: "0130"
  },
  {
    numero: "0132",
    provincia: "GRAN BUENOS AIRES",
    localidad: "FLORENCIO VARELA",
    label: "FLORENCIO VARELA",
    direccion: "A.J.VAZQUEZ ESQ.S.MARTIN",
    value: "0132"
  },
  {
    numero: "0133",
    provincia: "GRAN BUENOS AIRES",
    localidad: "PILAR",
    label: "PARQUE INDUSTRIAL PILAR",
    direccion: "CALLE 9 NRO 1761",
    value: "0133"
  },
  {
    numero: "0143",
    provincia: "CAPITAL FEDERAL",
    localidad: "FLORESTA",
    label: "PLAZA VELEZ SARFIELD",
    direccion: "AVENIDA GAONA 3720",
    value: "0143"
  },
  {
    numero: "0136",
    provincia: "GRAN BUENOS AIRES",
    localidad: "LAFERRERE",
    label: "GREGORIO DE LAFERRERE",
    direccion: "AV. LURO 5960",
    value: "0136"
  },
  {
    numero: "0140",
    provincia: "GRAN BUENOS AIRES",
    localidad: "BURZACO",
    label: "BURZACO",
    direccion: "ROCA 1097",
    value: "0140"
  },
  {
    numero: "0142",
    provincia: "GRAN BUENOS AIRES",
    localidad: "EZEIZA",
    label: "EZEIZA",
    direccion: "RAFAEL RAMOS MEJIA 173",
    value: "0142"
  },
  {
    numero: "0144",
    provincia: "GRAN BUENOS AIRES",
    localidad: "CAMPANA",
    label: "CAMPANA",
    direccion: "ING. AGUSTIN ROCA 93",
    value: "0144"
  },
  {
    numero: "0147",
    provincia: "GRAN BUENOS AIRES",
    localidad: "VILLA MARTELLI",
    label: "VILLA MARTELLI",
    direccion: "LAPRIDA 3943",
    value: "0147"
  },
  {
    numero: "0150",
    provincia: "GRAN BUENOS AIRES",
    localidad: "VALENTIN ALSINA",
    label: "VALENTIN ALSINA",
    direccion: "PRESIDENTE PERON 2675/9",
    value: "0150"
  },
  {
    numero: "0151",
    provincia: "GRAN BUENOS AIRES",
    localidad: "EL PALOMAR",
    label: "EL PALOMAR",
    direccion: "ITACUMBU 664",
    value: "0151"
  },
  {
    numero: "0154",
    provincia: "GRAN BUENOS AIRES",
    localidad: "SAN ISIDRO",
    label: "SAN ISIDRO CENTRO",
    direccion: "25 DE MAYO 193",
    value: "0154"
  },
  {
    numero: "0156",
    provincia: "GRAN BUENOS AIRES",
    localidad: "CASEROS",
    label: "CASEROS CENTRO",
    direccion: "AV. SAN MARTIN 2593",
    value: "0156"
  },
  {
    numero: "0149",
    provincia: "CAPITAL FEDERAL",
    localidad: "FLORES",
    label: "PLAZA IRLANDA",
    direccion: "AV. GAONA 2508",
    value: "0149"
  },
  {
    numero: "0167",
    provincia: "GRAN BUENOS AIRES",
    localidad: "ADROGUE",
    label: "ADROGUE",
    direccion: "ESTEBAN ADROGUE 1029",
    value: "0167"
  },
  {
    numero: "0169",
    provincia: "GRAN BUENOS AIRES",
    localidad: "HAEDO",
    label: "HAEDO",
    direccion: "AV. RIVADAVIA 16267",
    value: "0169"
  },
  {
    numero: "0170",
    provincia: "GRAN BUENOS AIRES",
    localidad: "RAMOS MEJIA",
    label: "RAMOS MEJIA",
    direccion: "AV. DE MAYO 149/151",
    value: "0170"
  },
  {
    numero: "0171",
    provincia: "GRAN BUENOS AIRES",
    localidad: "TIGRE",
    label: "TIGRE",
    direccion: "CAZON 1374",
    value: "0171"
  },
  {
    numero: "0177",
    provincia: "GRAN BUENOS AIRES",
    localidad: "BERISSO",
    label: "BERISSO",
    direccion: "MONTEVIDEO 601",
    value: "0177"
  },
  {
    numero: "0180",
    provincia: "GRAN BUENOS AIRES",
    localidad: "ENSENADA",
    label: "ENSENADA",
    direccion: "LA MERCED 198",
    value: "0180"
  },
  {
    numero: "0181",
    provincia: "GRAN BUENOS AIRES",
    localidad: "WILDE",
    label: "WILDE",
    direccion: "AV. MITRE 6250/52",
    value: "0181"
  },
  {
    numero: "0183",
    provincia: "GRAN BUENOS AIRES",
    localidad: "CITY BELL",
    label: "CITY BELL",
    direccion: "PLAZA BELGRANO 101",
    value: "0183"
  },
  {
    numero: "0155",
    provincia: "CAPITAL FEDERAL",
    localidad: "SAN NICOLAS",
    label: "DIAGONAL",
    direccion: "ESMERALDA 199",
    value: "0155"
  },
  {
    numero: "0165",
    provincia: "CAPITAL FEDERAL",
    localidad: "PALERMO",
    label: "ANCHORENA",
    direccion: "AV. SANTA FE 2699",
    value: "0165"
  },
  {
    numero: "0188",
    provincia: "GRAN BUENOS AIRES",
    localidad: "MONTE GRANDE",
    label: "MONTE GRANDE",
    direccion: "SANTAMARINA 476-78",
    value: "0188"
  },
  {
    numero: "0189",
    provincia: "GRAN BUENOS AIRES",
    localidad: "CASTELAR",
    label: "CASTELAR",
    direccion: "AV. I. ARIAS 2425",
    value: "0189"
  },
  {
    numero: "0191",
    provincia: "GRAN BUENOS AIRES",
    localidad: "GRAL.RODRIGUEZ",
    label: "GRAL.RODRIGUEZ",
    direccion: "AV. SAN MARTIN 98",
    value: "0191"
  },
  {
    numero: "0193",
    provincia: "GRAN BUENOS AIRES",
    localidad: "NORDELTA",
    label: "NORDELTA",
    direccion: "AV.DE LOS LAGOS 6660 (C.COM.LOC.11 Y 12)",
    value: "0193"
  },
  {
    numero: "0195",
    provincia: "GRAN BUENOS AIRES",
    localidad: "TORTUGUITAS",
    label: "TORTUGAS OPEN MALL",
    direccion: "CONSTITUYENTES Y AUT PANAMERIC ACC NORTE",
    value: "0195"
  },
  {
    numero: "0199",
    provincia: "GRAN BUENOS AIRES",
    localidad: "TEMPERLEY",
    label: "TEMPERLEY",
    direccion: "HIPOLITO YRIGOYEN 10.598",
    value: "0199"
  },
  {
    numero: "0201",
    provincia: "SANTA FE",
    localidad: "ROSARIO",
    label: "ARROYITO",
    direccion: "AV. ALBERDI 863",
    value: "0201"
  },
  {
    numero: "0202",
    provincia: "CORDOBA",
    localidad: "CORDOBA",
    label: "CORDOBA CENTRO",
    direccion: "BUENOS AIRES 1",
    value: "0202"
  },
  {
    numero: "0166",
    provincia: "CAPITAL FEDERAL",
    localidad: "SAN NICOLAS",
    label: "GALERIAS PACIFICO",
    direccion: "FLORIDA 802",
    value: "0166"
  },
  {
    numero: "0206",
    provincia: "SANTA CRUZ",
    localidad: "CALETA OLIVIA",
    label: "CALETA OLIVIA",
    direccion: "EVA PERON 340(ESQUINA SALVADOR GAVIOTA)",
    value: "0206"
  },
  {
    numero: "0207",
    provincia: "SANTA FE",
    localidad: "RAFAELA",
    label: "RAFAELA",
    direccion: "BOULEVARD LEHMAN 148",
    value: "0207"
  },
  {
    numero: "0173",
    provincia: "CAPITAL FEDERAL",
    localidad: "CABALLITO",
    label: "AV. LA PLATA",
    direccion: "AV. LA PLATA 1805",
    value: "0173"
  },
  {
    numero: "0209",
    provincia: "SANTA FE",
    localidad: "ROSARIO",
    label: "TIRO SUIZO",
    direccion: "SAN MARTIN 5091/99",
    value: "0209"
  },
  {
    numero: "0210",
    provincia: "SANTA FE",
    localidad: "SANTA FE",
    label: "SANTA FE",
    direccion: "SAN MARTIN 2515/25",
    value: "0210"
  },
  {
    numero: "0212",
    provincia: "ENTRE RIOS",
    localidad: "CONCEP.DEL URUGUAY",
    label: "CONCEPCION DEL URUGUAY",
    direccion: "9 DE JULIO 876",
    value: "0212"
  },
  {
    numero: "0214",
    provincia: "GRAN BUENOS AIRES",
    localidad: "MAR DEL PLATA",
    label: "GUEMES-MAR DEL PLATA",
    direccion: "GUEMES 2648",
    value: "0214"
  },
  {
    numero: "0174",
    provincia: "CAPITAL FEDERAL",
    localidad: "PALERMO",
    label: "BOTANICO",
    direccion: "SCALABRINI ORTIZ 2486/88",
    value: "0174"
  },
  {
    numero: "0178",
    provincia: "CAPITAL FEDERAL",
    localidad: "PALERMO",
    label: "AV.LAS HERAS",
    direccion: "AV. LAS HERAS 2332-40",
    value: "0178"
  },
  {
    numero: "0215",
    provincia: "TUCUMAN",
    localidad: "S.M.DE TUCUMAN",
    label: "TUCUMAN",
    direccion: "SAN MARTIN 622 ESQ. MENDOZA",
    value: "0215"
  },
  {
    numero: "0179",
    provincia: "CAPITAL FEDERAL",
    localidad: "FLORES",
    label: "AV.PEDRO GOYENA",
    direccion: "AV. PEDRO GOYENA 1192",
    value: "0179"
  },
  {
    numero: "0182",
    provincia: "CAPITAL FEDERAL",
    localidad: "SAN TELMO",
    label: "AV.BELGRANO",
    direccion: "BELGRANO 680-698",
    value: "0182"
  },
  {
    numero: "0216",
    provincia: "CORRIENTES",
    localidad: "CORRIENTES",
    label: "CIUDAD DE CORRIENTES",
    direccion: "CORDOBA 960",
    value: "0216"
  },
  {
    numero: "0217",
    provincia: "NEUQUEN",
    localidad: "NEUQUEN",
    label: "NEUQUEN",
    direccion: "AV. ARGENTINA 157",
    value: "0217"
  },
  {
    numero: "0218",
    provincia: "CHACO",
    localidad: "RESISTENCIA",
    label: "RESISTENCIA",
    direccion: "JOSE MARIA PAZ 66",
    value: "0218"
  },
  {
    numero: "0219",
    provincia: "NEUQUEN",
    localidad: "SAN MARTIN DE LOS ANDES",
    label: "SAN MARTIN DE LOS ANDES",
    direccion: "AV. SAN MARTIN 1093",
    value: "0219"
  },
  {
    numero: "0184",
    provincia: "CAPITAL FEDERAL",
    localidad: "CABALLITO",
    label: "AV.DIAZ VELEZ",
    direccion: "AV. DIAZ VELEZ 5253-65",
    value: "0184"
  },
  {
    numero: "0223",
    provincia: "TUCUMAN",
    localidad: "YERBA BUENA",
    label: "YERBA BUENA",
    direccion: "AV. ACONQUIJA 1620",
    value: "0223"
  },
  {
    numero: "0225",
    provincia: "SANTIAGO DEL ESTERO",
    localidad: "LA BANDA",
    label: "LA BANDA",
    direccion: "SARMIENTO 235/239",
    value: "0225"
  },
  {
    numero: "0228",
    provincia: "TIERRA DEL FUEGO",
    localidad: "RIO GRANDE",
    label: "RIO GRANDE",
    direccion: "AV. SAN MARTIN 165",
    value: "0228"
  },
  {
    numero: "0230",
    provincia: "MENDOZA",
    localidad: "TUNUYAN",
    label: "TUNUYAN",
    direccion: "AV. SAN MARTIN 1025",
    value: "0230"
  },
  {
    numero: "0186",
    provincia: "CAPITAL FEDERAL",
    localidad: "BELGRANO",
    label: "BELGRANO R",
    direccion: "ELCANO 3107/09",
    value: "0186"
  },
  {
    numero: "0231",
    provincia: "GRAN BUENOS AIRES",
    localidad: "VILLA RAMALLO",
    label: "VILLA RAMALLO",
    direccion: "AV. SAN MARTIN 621",
    value: "0231"
  },
  {
    numero: "0234",
    provincia: "NEUQUEN",
    localidad: "VILLA LA ANGOSTURA",
    label: "VILLA LA ANGOSTURA",
    direccion: "AV.ARRAYANES 90 (ESQ.CERRO BELVEDERE)L.3",
    value: "0234"
  },
  {
    numero: "0235",
    provincia: "GRAN BUENOS AIRES",
    localidad: "MAR DEL PLATA",
    label: "PUERTO",
    direccion: "12 DE OCTUBRE 3264",
    value: "0235"
  },
  {
    numero: "0187",
    provincia: "CAPITAL FEDERAL",
    localidad: "MATADEROS",
    label: "NUEVA MATADEROS",
    direccion: "AV. EVA PERON 4941",
    value: "0187"
  },
  {
    numero: "0196",
    provincia: "CAPITAL FEDERAL",
    localidad: "CAPITAL FEDERAL",
    label: "TORRE",
    direccion: "AV. CORDOBA 111",
    value: "0196"
  },
  {
    numero: "0301",
    provincia: "CAPITAL FEDERAL",
    localidad: "ONCE",
    label: "MISERERE",
    direccion: "AV. RIVADAVIA 2577/81",
    value: "0301"
  },
  {
    numero: "0302",
    provincia: "CAPITAL FEDERAL",
    localidad: "RETIRO",
    label: "NORTE",
    direccion: "URUGUAY 1031",
    value: "0302"
  },
  {
    numero: "0236",
    provincia: "SALTA",
    localidad: "SALTA",
    label: "TRES CERRITOS",
    direccion: "VIRREY TOLEDO 849",
    value: "0236"
  },
  {
    numero: "0237",
    provincia: "MENDOZA",
    localidad: "MENDOZA",
    label: "MENDOZA-CENTRO",
    direccion: "AV. ESPANA 1342",
    value: "0237"
  },
  {
    numero: "0239",
    provincia: "GRAN BUENOS AIRES",
    localidad: "MAR DEL PLATA",
    label: "AVENIDA CONSTITUCION",
    direccion: "AV. CONSTITUCION 4956",
    value: "0239"
  },
  {
    numero: "0304",
    provincia: "CAPITAL FEDERAL",
    localidad: "RECOLETA",
    label: "GRAND BOURG",
    direccion: "AV. DEL LIBERTADOR 2166",
    value: "0304"
  },
  {
    numero: "0305",
    provincia: "CAPITAL FEDERAL",
    localidad: "RECOLETA",
    label: "CALLAO",
    direccion: "AV. CALLAO 701",
    value: "0305"
  },
  {
    numero: "0240",
    provincia: "MENDOZA",
    localidad: "MENDOZA",
    label: "5TA. SECCION",
    direccion: "ARISTIDES VILLANUEVA 309",
    value: "0240"
  },
  {
    numero: "0243",
    provincia: "MISIONES",
    localidad: "POSADAS",
    label: "POSADAS",
    direccion: "COLON 1650",
    value: "0243"
  },
  {
    numero: "0306",
    provincia: "CAPITAL FEDERAL",
    localidad: "ALMAGRO",
    label: "ALMAGRO",
    direccion: "AV. LA PLATA 510",
    value: "0306"
  },
  {
    numero: "0244",
    provincia: "CORDOBA",
    localidad: "CORDOBA",
    label: "AV.COLON LA CANADA",
    direccion: "AV. COLON 406",
    value: "0244"
  },
  {
    numero: "0247",
    provincia: "CORDOBA",
    localidad: "BARRIO SARMIENTO",
    label: "BARRIO SARMIENTO",
    direccion: "AV. SABATTINI 2301",
    value: "0247"
  },
  {
    numero: "0252",
    provincia: "CHUBUT",
    localidad: "Esquel",
    label: "ESQUEL",
    direccion: "CALLE 9 NRO: 999 ESQ. 25 DE MAYO",
    value: "0252"
  },
  {
    numero: "0307",
    provincia: "CAPITAL FEDERAL",
    localidad: "BELGRANO",
    label: "BELGRANO",
    direccion: "MONROE 3099",
    value: "0307"
  },
  {
    numero: "0308",
    provincia: "CAPITAL FEDERAL",
    localidad: "SAN CRISTOBAL",
    label: "SAN CRISTOBAL",
    direccion: "AV. SAN JUAN 2654",
    value: "0308"
  },
  {
    numero: "0253",
    provincia: "SANTA FE",
    localidad: "VENADO TUERTO",
    label: "VENADO TUERTO",
    direccion: "SAN MARTIN 755",
    value: "0253"
  },
  {
    numero: "0309",
    provincia: "CAPITAL FEDERAL",
    localidad: "VILLA PUEYRREDON",
    label: "VILLA PUEYRREDON",
    direccion: "AV. MOSCONI 2816",
    value: "0309"
  },
  {
    numero: "0256",
    provincia: "JUJUY",
    localidad: "S.S.DE JUJUY",
    label: "JUJUY",
    direccion: "ALVEAR 992",
    value: "0256"
  },
  {
    numero: "0313",
    provincia: "CAPITAL FEDERAL",
    localidad: "RECOLETA",
    label: "ALVEAR",
    direccion: "AV. ALVEAR 1528",
    value: "0313"
  },
  {
    numero: "0316",
    provincia: "CAPITAL FEDERAL",
    localidad: "RETIRO",
    label: "CATALINAS",
    direccion: "AV. LEANDRO N. ALEM 996",
    value: "0316"
  },
  {
    numero: "0317",
    provincia: "CAPITAL FEDERAL",
    localidad: "COLEGIALES",
    label: "COLEGIALES",
    direccion: "FEDERICO LACROZE 2451/53",
    value: "0317"
  },
  {
    numero: "0258",
    provincia: "RIO NEGRO",
    localidad: "S.C.BARILOCHE",
    label: "BARILOCHE",
    direccion: "SAN MARTIN 336",
    value: "0258"
  },
  {
    numero: "0259",
    provincia: "CORDOBA",
    localidad: "ALTA CORDOBA",
    label: "ALTA CORDOBA",
    direccion: "JOSE B. BAIGORRI 799",
    value: "0259"
  },
  {
    numero: "0318",
    provincia: "CAPITAL FEDERAL",
    localidad: "LINIERS",
    label: "LINIERS",
    direccion: "AV. RIVADAVIA 11190",
    value: "0318"
  },
  {
    numero: "0319",
    provincia: "CAPITAL FEDERAL",
    localidad: "MONSERRAT",
    label: "MONTSERRAT",
    direccion: "MORENO 998",
    value: "0319"
  },
  {
    numero: "0261",
    provincia: "MENDOZA",
    localidad: "RIVADAVIA",
    label: "RIVADAVIA MZA.",
    direccion: "SAN ISIDRO 646",
    value: "0261"
  },
  {
    numero: "0320",
    provincia: "CAPITAL FEDERAL",
    localidad: "SAN NICOLAS",
    label: "AV. CORRIENTES",
    direccion: "AV. CORRIENTES 942",
    value: "0320"
  },
  {
    numero: "0326",
    provincia: "CAPITAL FEDERAL",
    localidad: "CAPITAL FEDERAL",
    label: "VILLA DEL PARQUE",
    direccion: "CUENCA 3401",
    value: "0326"
  },
  {
    numero: "0262",
    provincia: "FORMOSA",
    localidad: "FORMOSA",
    label: "FORMOSA",
    direccion: "AV. 25 DE MAYO 311",
    value: "0262"
  },
  {
    numero: "0263",
    provincia: "GRAN BUENOS AIRES",
    localidad: "JUNIN",
    label: "JUNIN",
    direccion: "BARTOLOME MITRE 81",
    value: "0263"
  },
  {
    numero: "0264",
    provincia: "LA PAMPA",
    localidad: "SANTA ROSA",
    label: "SANTA ROSA",
    direccion: "CARLOS PELLEGRINI 355",
    value: "0264"
  },
  {
    numero: "0327",
    provincia: "CAPITAL FEDERAL",
    localidad: "ALMAGRO",
    label: "PUEYRREDON",
    direccion: "AV. PUEYRREDON 1001",
    value: "0327"
  },
  {
    numero: "0265",
    provincia: "LA RIOJA",
    localidad: "LA RIOJA",
    label: "LA RIOJA",
    direccion: "SAN NICOLAS DE BARI 476",
    value: "0265"
  },
  {
    numero: "0266",
    provincia: "CATAMARCA",
    localidad: "CATAMARCA",
    label: "CATAMARCA",
    direccion: "RIVADAVIA 520",
    value: "0266"
  },
  {
    numero: "0267",
    provincia: "CORDOBA",
    localidad: "RIO CUARTO",
    label: "RIO CUARTO",
    direccion: "SOBREMONTE 695",
    value: "0267"
  },
  {
    numero: "0269",
    provincia: "MENDOZA",
    localidad: "SAN MARTIN",
    label: "GENERAL SAN MARTIN",
    direccion: "AVELLANEDA ESQ.B.SUR MER",
    value: "0269"
  },
  {
    numero: "0270",
    provincia: "SAN LUIS",
    localidad: "SAN LUIS",
    label: "SAN LUIS",
    direccion: "JOSE G. ARTIGAS 824",
    value: "0270"
  },
  {
    numero: "0271",
    provincia: "SAN LUIS",
    localidad: "VILLA MERCEDES",
    label: "VILLA MERCEDES",
    direccion: "PEDERNERA 524",
    value: "0271"
  },
  {
    numero: "0272",
    provincia: "SANTA CRUZ",
    localidad: "RIO GALLEGOS",
    label: "RIO GALLEGOS",
    direccion: "SARMIENTO 40",
    value: "0272"
  },
  {
    numero: "0274",
    provincia: "CORDOBA",
    localidad: "VILLA CARLOS PAZ",
    label: "VILLA CARLOS PAZ",
    direccion: "AV. GRAL. SAN MARTIN 65",
    value: "0274"
  },
  {
    numero: "0275",
    provincia: "CORDOBA",
    localidad: "VILLA MARIA",
    label: "VILLA MARIA",
    direccion: "GENERAL PAZ 45",
    value: "0275"
  },
  {
    numero: "0276",
    provincia: "CORDOBA",
    localidad: "SAN FRANCISCO",
    label: "SAN FRANCISCO",
    direccion: "AV. 25 DE MAYO 1591",
    value: "0276"
  },
  {
    numero: "0328",
    provincia: "CAPITAL FEDERAL",
    localidad: "MATADEROS",
    label: "MATADEROS",
    direccion: "AV. J. B. ALBERDI 6401",
    value: "0328"
  },
  {
    numero: "0279",
    provincia: "MENDOZA",
    localidad: "SAN RAFAEL",
    label: "SAN RAFAEL",
    direccion: "HIPOLITO YRIGOYEN 191",
    value: "0279"
  },
  {
    numero: "0280",
    provincia: "GRAN BUENOS AIRES",
    localidad: "OLAVARRIA",
    label: "OLAVARRIA",
    direccion: "NECOCHEA 3086",
    value: "0280"
  },
  {
    numero: "0282",
    provincia: "SANTA FE",
    localidad: "ROSARIO",
    label: "PASEO DEL SIGLO",
    direccion: "CORDOBA 1935",
    value: "0282"
  },
  {
    numero: "0283",
    provincia: "MENDOZA",
    localidad: "LUJAN DE CUYO",
    label: "LUJAN DE CUYO",
    direccion: "AV. SAN MARTIN 558",
    value: "0283"
  },
  {
    numero: "0284",
    provincia: "MENDOZA",
    localidad: "MAIPU",
    label: "MAIPU",
    direccion: "SAN MARTIN 198",
    value: "0284"
  },
  {
    numero: "0285",
    provincia: "MENDOZA",
    localidad: "GODOY CRUZ",
    label: "GODOY CRUZ",
    direccion: "AV. SAN MARTIN 926",
    value: "0285"
  },
  {
    numero: "0286",
    provincia: "MENDOZA",
    localidad: "GUAYMALLEN",
    label: "GUAYMALLEN",
    direccion: "AV. LIBERTAD 424",
    value: "0286"
  },
  {
    numero: "0288",
    provincia: "GRAN BUENOS AIRES",
    localidad: "TRES ARROYOS",
    label: "TRES ARROYOS",
    direccion: "COLON 301",
    value: "0288"
  },
  {
    numero: "0289",
    provincia: "CORDOBA",
    localidad: "RIO TERCERO",
    label: "RIO TERCERO",
    direccion: "S.MARTIN ESQ.V.SARSFIELD",
    value: "0289"
  },
  {
    numero: "0290",
    provincia: "CORDOBA",
    localidad: "B.CERRO DE LAS ROSAS",
    label: "CERRO DE LAS ROSAS",
    direccion: "AV. RAFAEL NUNEZ 4173",
    value: "0290"
  },
  {
    numero: "0291",
    provincia: "CORDOBA",
    localidad: "CORDOBA",
    label: "NUEVA CORDOBA",
    direccion: "ESTRADA 220",
    value: "0291"
  },
  {
    numero: "0292",
    provincia: "RIO NEGRO",
    localidad: "CIPOLLETI",
    label: "CIPOLLETTI",
    direccion: "ROCA 469",
    value: "0292"
  },
  {
    numero: "0293",
    provincia: "GRAN BUENOS AIRES",
    localidad: "NECOCHEA",
    label: "NECOCHEA",
    direccion: "CALLE 64 NRO 3041",
    value: "0293"
  },
  {
    numero: "0329",
    provincia: "CAPITAL FEDERAL",
    localidad: "SAN NICOLAS",
    label: "AV.DE MAYO",
    direccion: "AV. DE MAYO 1165",
    value: "0329"
  },
  {
    numero: "0294",
    provincia: "SANTA FE",
    localidad: "VILLA CONSTITUCION",
    label: "VILLA CONSTITUCION",
    direccion: "LISANDRO DE LA TORRE 380",
    value: "0294"
  },
  {
    numero: "0295",
    provincia: "CHACO",
    localidad: "P.ROQUE SAENZ PENA",
    label: "ROQUE SAENZ PENA",
    direccion: "SAN MARTIN 633 (CALLE 12)",
    value: "0295"
  },
  {
    numero: "0296",
    provincia: "SANTA FE",
    localidad: "SAN LORENZO",
    label: "SAN LORENZO",
    direccion: "SAN MARTIN 1102",
    value: "0296"
  },
  {
    numero: "0330",
    provincia: "CAPITAL FEDERAL",
    localidad: "TRIBUNALES",
    label: "TRIBUNALES",
    direccion: "AV. CORRIENTES 1401",
    value: "0330"
  },
  {
    numero: "0297",
    provincia: "CHUBUT",
    localidad: "TRELEW",
    label: "TRELEW",
    direccion: "BELGRANO 272",
    value: "0297"
  },
  {
    numero: "0298",
    provincia: "CHUBUT",
    localidad: "PUERTO MADRYN",
    label: "PUERTO MADRYN",
    direccion: "ROQUE SAENZ PENA 30",
    value: "0298"
  },
  {
    numero: "0299",
    provincia: "TIERRA DEL FUEGO",
    localidad: "USHUAIA",
    label: "USHUAIA",
    direccion: "MAIPU 65",
    value: "0299"
  },
  {
    numero: "0311",
    provincia: "GRAN BUENOS AIRES",
    localidad: "VILLA BALLESTER",
    label: "VILLA BALLESTER",
    direccion: "ALVEAR 26",
    value: "0311"
  },
  {
    numero: "0314",
    provincia: "",
    localidad: "VICENTE LOPEZ",
    label: "VICENTE LOPEZ",
    direccion: "ALSINA 1496",
    value: "0314"
  },
  {
    numero: "0321",
    provincia: "GRAN BUENOS AIRES",
    localidad: "AVELLANEDA",
    label: "AVELLANEDA",
    direccion: "AV. MITRE 602",
    value: "0321"
  },
  {
    numero: "0322",
    provincia: "GRAN BUENOS AIRES",
    localidad: "LANUS",
    label: "LANUS",
    direccion: "AV. H. YRIGOYEN 4602",
    value: "0322"
  },
  {
    numero: "0323",
    provincia: "GRAN BUENOS AIRES",
    localidad: "LOMAS DE ZAMORA",
    label: "LOMAS DE ZAMORA",
    direccion: "LEANDRO N. ALEM 76",
    value: "0323"
  },
  {
    numero: "0325",
    provincia: "GRAN BUENOS AIRES",
    localidad: "PILAR",
    label: "PILAR",
    direccion: "ITUZAINGO 401",
    value: "0325"
  },
  {
    numero: "0331",
    provincia: "GRAN BUENOS AIRES",
    localidad: "BOULOGNE",
    label: "PANAMERICANA",
    direccion: "AV. ROLON 299",
    value: "0331"
  },
  {
    numero: "0334",
    provincia: "GRAN BUENOS AIRES",
    localidad: "ITUZAINGO",
    label: "ITUZAINGO",
    direccion: "24 DE OCTUBRE 876",
    value: "0334"
  },
  {
    numero: "0332",
    provincia: "CAPITAL FEDERAL",
    localidad: "PALERMO",
    label: "AV.SANTA FE",
    direccion: "AV. SANTA FE 2121",
    value: "0332"
  },
  {
    numero: "0336",
    provincia: "GRAN BUENOS AIRES",
    localidad: "LA LUCILA",
    label: "LA LUCILA",
    direccion: "AV. MAIPU 4164",
    value: "0336"
  },
  {
    numero: "0337",
    provincia: "GRAN BUENOS AIRES",
    localidad: "MORON",
    label: "MORON",
    direccion: "ALMIRANTE BROWN 965",
    value: "0337"
  },
  {
    numero: "0338",
    provincia: "GRAN BUENOS AIRES",
    localidad: "BERAZATEGUI",
    label: "BERAZATEGUI",
    direccion: "CALLE 14 NRO 4764",
    value: "0338"
  },
  {
    numero: "0340",
    provincia: "GRAN BUENOS AIRES",
    localidad: "ZARATE",
    label: "ZARATE",
    direccion: "BELGRANO 702",
    value: "0340"
  },
  {
    numero: "0344",
    provincia: "GRAN BUENOS AIRES",
    localidad: "SAN MIGUEL",
    label: "SAN MIGUEL",
    direccion: "AV.PRESIDENTE PERON 1226",
    value: "0344"
  },
  {
    numero: "0347",
    provincia: "GRAN BUENOS AIRES",
    localidad: "MARTINEZ",
    label: "MARTINEZ",
    direccion: "AV.SANTA FE 1860",
    value: "0347"
  },
  {
    numero: "0351",
    provincia: "GRAN BUENOS AIRES",
    localidad: "BANFIELD",
    label: "BANFIELD",
    direccion: "AV. H. YRIGOYEN 7853",
    value: "0351"
  },
  {
    numero: "0353",
    provincia: "GRAN BUENOS AIRES",
    localidad: "ESCOBAR",
    label: "ESCOBAR",
    direccion: "AV. MITRE 640",
    value: "0353"
  },
  {
    numero: "0354",
    provincia: "GRAN BUENOS AIRES",
    localidad: "OLIVOS",
    label: "OLIVOS",
    direccion: "AV. MAIPU 2894",
    value: "0354"
  },
  {
    numero: "0361",
    provincia: "GRAN BUENOS AIRES",
    localidad: "LA PLATA",
    label: "NUEVA LA PLATA",
    direccion: "CALLE 46 NRO. 565",
    value: "0361"
  },
  {
    numero: "0367",
    provincia: "GRAN BUENOS AIRES",
    localidad: "MORENO",
    label: "SHOPPING NINE",
    direccion: "AV.VICTORIA 1128",
    value: "0367"
  },
  {
    numero: "0339",
    provincia: "CAPITAL FEDERAL",
    localidad: "VILLA URQUIZA",
    label: "VILLA URQUIZA",
    direccion: "AV. TRIUNVIRATO 4274",
    value: "0339"
  },
  {
    numero: "0341",
    provincia: "CAPITAL FEDERAL",
    localidad: "SAN NICOLAS",
    label: "PUERTO VIAMONTE",
    direccion: "A.MOREAU DE JUSTO 228",
    value: "0341"
  },
  {
    numero: "0342",
    provincia: "CAPITAL FEDERAL",
    localidad: "SAN NICOLAS",
    label: "FLORIDA",
    direccion: "PERON JUAN DOMINGO TTE. GRAL.588",
    value: "0342"
  },
  {
    numero: "0368",
    provincia: "GRAN BUENOS AIRES",
    localidad: "ESCOBAR",
    label: "MASCHWITZ",
    direccion: "SANTIAGO DEL ESTERO 690",
    value: "0368"
  },
  {
    numero: "0376",
    provincia: "CORDOBA",
    localidad: "GUALEGUAY",
    label: "GUALEGUAY",
    direccion: "SAN ANTONIO 100",
    value: "0376"
  },
  {
    numero: "0346",
    provincia: "CAPITAL FEDERAL",
    localidad: "SAN NICOLAS",
    label: "CONGRESO",
    direccion: "AV. CALLAO 257/63",
    value: "0346"
  },
  {
    numero: "0379",
    provincia: "CORDOBA",
    localidad: "CORDOBA",
    label: "MARCOS JUAREZ",
    direccion: "AV. BELGRANO 930",
    value: "0379"
  },
  {
    numero: "0381",
    provincia: "SAN JUAN",
    localidad: "Dpto. Rivadavia",
    label: "RIVADAVIA SAN JUAN",
    direccion: "AV.LIBERTADOR SAN MARTIN N.3558",
    value: "0381"
  },
  {
    numero: "0382",
    provincia: "GRAN BUENOS AIRES",
    localidad: "9 DE JULIO",
    label: "9 DE JULIO",
    direccion: "HIPOLITO IRIGOYEN 921 - PROV. DE BS AS",
    value: "0382"
  },
  {
    numero: "0383",
    provincia: "LA PAMPA",
    localidad: "GRAL. PICO",
    label: "GENERAL PICO",
    direccion: "CALLE 22 N605 - GRAL.PICO",
    value: "0383"
  },
  {
    numero: "0352",
    provincia: "CAPITAL FEDERAL",
    localidad: "BELGRANO",
    label: "L.M.CAMPOS",
    direccion: "LUIS MARIA CAMPOS 1383",
    value: "0352"
  },
  {
    numero: "0384",
    provincia: "GRAN BUENOS AIRES",
    localidad: "TRENQUE LAUQUEN",
    label: "TRENQUE LAUQUEN",
    direccion: "AV.VILLEGAS 418",
    value: "0384"
  },
  {
    numero: "0356",
    provincia: "CAPITAL FEDERAL",
    localidad: "NUÑEZ",
    label: "NUNEZ",
    direccion: "AV. CABILDO 3622/24",
    value: "0356"
  },
  {
    numero: "0357",
    provincia: "CAPITAL FEDERAL",
    localidad: "CAPITAL FEDERAL",
    label: "ALVAREZ THOMAS",
    direccion: "ALVAREZ THOMAS 402/418",
    value: "0357"
  },
  {
    numero: "0386",
    provincia: "CORDOBA",
    localidad: "ARROYITO",
    label: "ARROYITO CORDOBA",
    direccion: "AVENIDA FULVIO PAGANI 1326",
    value: "0386"
  },
  {
    numero: "0387",
    provincia: "CHUBUT",
    localidad: "COMODORO RIVADAVIA",
    label: "NUEVA COMODORO RIVADAVIA",
    direccion: "HIPOLITO IRIGOYEN 2386",
    value: "0387"
  },
  {
    numero: "0418",
    provincia: "SANTA FE",
    localidad: "SANTA FE",
    label: "CANDIOTI",
    direccion: "BOULEVARD GALVEZ 1875",
    value: "0418"
  },
  {
    numero: "0999",
    provincia: "CAPITAL FEDERAL",
    localidad: "SAN NICOLAS",
    label: "CATEDRAL",
    direccion: "RECONQUISTA 2",
    value: "0999"
  },
  {
    numero: "9999",
    provincia: "PRESCRIPTORES",
    localidad: "PRESCRIPTORES",
    label: "PRESCRIPTORES",
    direccion: "PRESCRIPTORES",
    value: "9999"
  }
];
const franjasHorarias = [
  {
    label: "de 9 a 12 hs.",
    value: "de 9 a 12 hs."
  },
  {
    label: "de 12 a 15 hs.",
    value: "de 12 a 15 hs."
  },
  {
    label: "de 15 a 18 hs.",
    value: "de 15 a 18 hs."
  }
];

const nacionalidades = [
  { label: "ARGENTINA", value: "80" },
  { label: "AFGANISTAN", value: "65" },
  { label: "ALBANIA", value: "52" },
  { label: "ALEMANIA", value: "3" },
  { label: "ALTO VOLTA", value: "100" },
  { label: "ANDORRA", value: "101" },
  { label: "ANGOLA", value: "164" },
  { label: "ARABE SIRIA", value: "35" },
  { label: "ARABIA SAUDITA", value: "53" },
  { label: "ARGELIA", value: "102" },
  { label: "AUSTRALIA", value: "21" },
  { label: "AUSTRIA", value: "13" },
  { label: "BAHAMAS", value: "48" },
  { label: "BAHERIN", value: "149" },
  { label: "BANGLADESH", value: "165" },
  { label: "BARBADOS", value: "150" },
  { label: "BELGICA", value: "6" },
  { label: "BENIM", value: "113" },
  { label: "BHUTAN", value: "73" },
  { label: "BIRMANIA", value: "89" },
  { label: "BOLIVIA", value: "41" },
  { label: "BOTSWANA", value: "151" },
  { label: "BRASIL", value: "12" },
  { label: "BRUNEI", value: "174" },
  { label: "BULGARIA", value: "45" },
  { label: "BURUNDI", value: "104" },
  { label: "CABO VERDE", value: "172" },
  { label: "CAMERUM", value: "106" },
  { label: "CANADA", value: "17" },
  { label: "CENTRO AFRICANA", value: "107" },
  { label: "CHAD", value: "111" },
  { label: "CHECOSLOVAQUIA", value: "14" },
  { label: "CHILE", value: "11" },
  { label: "CHINA", value: "83" },
  { label: "CHIPRE", value: "112" },
  { label: "COLOMBIA", value: "54" },
  { label: "COMORAS", value: "184" },
  { label: "CONGO", value: "152" },
  { label: "COREA", value: "44" },
  { label: "COSTA DE MARFIL", value: "110" },
  { label: "COSTA RICA", value: "55" },
  { label: "CROACIA", value: "254" },
  { label: "CUBA", value: "51" },
  { label: "DINAMARCA", value: "15" },
  { label: "DJIBOUTIA", value: "185" },
  { label: "DOMINICA", value: "163" },
  { label: "DOMINICANA", value: "76" },
  { label: "ECUADOR", value: "47" },
  { label: "EGIPTO", value: "57" },
  { label: "EL SALVADOR", value: "58" },
  { label: "EMIRATOS ARABES", value: "153" },
  { label: "ESLOVENIA", value: "255" },
  { label: "ESPANIA", value: "9" },
  { label: "ESTADOS UNIDOS", value: "2" },
  { label: "ETIOPIA SOC", value: "59" },
  { label: "FIJI", value: "186" },
  { label: "FILIPINAS", value: "85" },
  { label: "FINLANDIA", value: "37" },
  { label: "FRANCIA", value: "4" },
  { label: "GABONESA", value: "114" },
  { label: "GAMBIA", value: "154" },
  { label: "GHANA", value: "115" },
  { label: "GRECIA", value: "38" },
  { label: "GRENADA", value: "162" },
  { label: "GUATEMALA", value: "61" },
  { label: "GUAYANA", value: "97" },
  { label: "GUINEA", value: "116" },
  { label: "GUINEA BISSAU", value: "92" },
  { label: "GUINEA ECUATORIAL", value: "155" },
  { label: "HAITI", value: "62" },
  { label: "HOLANDA", value: "8" },
  { label: "HONDURAS", value: "63" },
  { label: "HONG KONG", value: "183" },
  { label: "HUNGRIA", value: "34" },
  { label: "INDIA", value: "20" },
  { label: "INDONESIA", value: "90" },
  { label: "IRAK", value: "86" },
  { label: "IRAN", value: "36" },
  { label: "IRLANDA", value: "24" },
  { label: "ISLANDIA", value: "18" },
  { label: "ISRAEL", value: "39" },
  { label: "ITALIA", value: "7" },
  { label: "JAMAICA", value: "117" },
  { label: "JAPON", value: "19" },
  { label: "JORDANIA", value: "118" },
  { label: "KAMPUCHEA DEMOC.", value: "105" },
  { label: "KENIA", value: "119" },
  { label: "KUWAIT", value: "120" },
  { label: "LESOTHO", value: "166" },
  { label: "LIBANESA", value: "32" },
  { label: "LIBERIA", value: "64" },
  { label: "LIBIA", value: "122" },
  { label: "LIECHTENSTEIN", value: "123" },
  { label: "LITUANIA", value: "49" },
  { label: "LUXEMBURGO", value: "43" },
  { label: "MADAGASCAR", value: "124" },
  { label: "MALASIA", value: "156" },
  { label: "MALAWI", value: "157" },
  { label: "MALDIVAS", value: "167" },
  { label: "MALI", value: "125" },
  { label: "MALTA", value: "168" },
  { label: "MALTA (OR.MIL)", value: "171" },
  { label: "MARRUECOS", value: "126" },
  { label: "MAURICIO", value: "158" },
  { label: "MAURITANIA", value: "127" },
  { label: "MEXICO", value: "33" },
  { label: "MONACO", value: "129" },
  { label: "MONGOLIA", value: "128" },
  { label: "MONTENEGRO", value: "252" },
  { label: "MOZAMBIQUE", value: "187" },
  { label: "NAURU", value: "177" },
  { label: "NEPAL", value: "130" },
  { label: "NICARAGUA", value: "67" },
  { label: "NIGER", value: "131" },
  { label: "NIGERIA", value: "132" },
  { label: "NORUEGA", value: "28" },
  { label: "NUEVA CALEDONIA", value: "175" },
  { label: "NUEVA ZELANDIA", value: "22" },
  { label: "NVAS.HEBRIDAS", value: "96" },
  { label: "OMAN", value: "159" },
  { label: "PAKISTAN", value: "42" },
  { label: "PANAMA", value: "68" },
  { label: "PAPUA Y NVA.GUINEA", value: "169" },
  { label: "PARAGUAY", value: "69" },
  { label: "PERU", value: "26" },
  { label: "POLONIA", value: "30" },
  { label: "PORTUGAL", value: "16" },
  { label: "PTO.RICO", value: "66" },
  { label: "QATAR", value: "160" },
  { label: "REINO UNIDO", value: "1" },
  { label: "REPUBLICA DE ARMENIA", value: "250" },
  { label: "RUANDA", value: "133" },
  { label: "RUMANIA", value: "31" },
  { label: "SALOMON", value: "173" },
  { label: "SAN MARINO", value: "135" },
  { label: "SAN VICENTE Y LAS GRANADINAS", value: "170" },
  { label: "SANTA LUCIA", value: "178" },
  { label: "SANTA SEDE", value: "78" },
  { label: "SANTO TOME Y PRINCIPE", value: "179" },
  { label: "SENEGAL", value: "136" },
  { label: "SERBIA", value: "251" },
  { label: "SEYCHELLES", value: "188" },
  { label: "SIERRA LEONA", value: "137" },
  { label: "SINGAPUR", value: "182" },
  { label: "SOMALIA", value: "94" },
  { label: "SRI LANKA", value: "88" },
  { label: "SUDAFRICA", value: "23" },
  { label: "SUDAN", value: "138" },
  { label: "SUECIA", value: "27" },
  { label: "SUIZA", value: "5" },
  { label: "SURINAME", value: "199" },
  { label: "SURINAME,REPUBLICA DE", value: "139" },
  { label: "SWAZILANDIA", value: "180" },
  { label: "TAIWAN", value: "56" },
  { label: "TANZANIA", value: "161" },
  { label: "THAILANDIA", value: "140" },
  { label: "TOGOLEN", value: "141" },
  { label: "TONGA", value: "181" },
  { label: "TRINIDAD Y TOBAGO", value: "142" },
  { label: "TUNECINA", value: "143" },
  { label: "TURQUIA", value: "46" },
  { label: "U.R.S.S.", value: "40" },
  { label: "UCRANIA", value: "253" },
  { label: "UGANDA", value: "144" },
  { label: "URUGUAY", value: "10" },
  { label: "VENEZUELA", value: "79" },
  { label: "VIETNAM", value: "145" },
  { label: "YEMEN,REP.ARABE", value: "147" },
  { label: "YEMEN,REP.EMOC.", value: "148" },
  { label: "YUGOSLAVIA", value: "29" },
  { label: "ZAIRE", value: "108" },
  { label: "ZAMBIA", value: "109" },
  { label: "ZIMBAWE", value: "176" }
];

const codigosAreaPopulares = [
  { label: "11 - BUENOS AIRES", value: "11" },
  { label: "220 - MARCOS PAZ - BUENOS AIRES", value: "220" },
  { label: "221 - LA PLATA - BUENOS AIRES", value: "221" },
  { label: "223 - MAR DEL PLATA - BUENOS AIRES", value: "223" },
  {
    label: "230 - LOS CARDALES / PILAR / VILLA ROSA - BUENOS AIRES",
    value: "230"
  },
  { label: "236 - JUNIN - BUENOS AIRES", value: "236" },
  { label: "237 - GENERAL RODRIGUEZ / MORENO- BUENOS AIRES", value: "237" },
  { label: "249 - TANDIL - BUENOS AIRES", value: "249" },
  { label: "260 - MALARGÜE - MENDOZA", value: "260" },
  { label: "261 - LUJAN DE CUYO / MENDOZA - MENDOZA", value: "261" },
  { label: "264 - SAN JUAN - SAN JUAN", value: "264" },
  { label: "266 - SAN LUIS - SAN LUIS", value: "266" },
  { label: "280 - RAWSON / TRELEW / PUERTO MADRYN - CHUBUT", value: "280" },
  { label: "291 - BAHIA BLANCA - BUENOS AIRES", value: "291" },
  {
    label:
      "294 - EL BOLSON / SAN CARLOS DE BARILOCHE / VILLA LA ANGOSTURA - RIO NEGRO",
    value: "294"
  },
  { label: "297 - COMODORO RIVADAVIA / CALETA OLIVIA - CHUBUT", value: "297" },
  { label: "298 - GENERAL ROCA / VILLA REGINA - RIO NEGRO", value: "298" },
  { label: "299 - PLOTTIER - NEUQUEN", value: "299" },
  {
    label:
      "341 - ROSARIO / FUNES / VILLA GOBERNADOR GALVEZ / CAPITAN BERMUDEZ - SANTA FE",
    value: "341"
  },
  { label: "342 - SANTA FE", value: "342" },
  { label: "345 - CONCORDIA - ENTRE RIOS", value: "345" },
  { label: "348 - GARIN / INGENIERO MASCHWITZ - BUENOS AIRES", value: "348" },
  { label: "351 - CORDOBA - CORDOBA", value: "351" },
  { label: "353 - VILLA MARIA - CORDOBA", value: "353" },
  { label: "358 - RIO CUARTO - CORDOBA", value: "358" },
  { label: "364 - QUITILIPI - CHACO", value: "364" },
  { label: "376 - POSADAS - MISIONES", value: "376" },
  { label: "381 - SAN MIGUEL DE TUCUMAN - TUCUMAN", value: "381" },
  { label: "387 - SALTA", value: "387" },
  { label: "2202 - GONZALEZ CATAN - BUENOS AIRES", value: "2202" },
  {
    label: "2225 - SAN VICENTE / ALEJANDRO KORN - BUENOS AIRES",
    value: "2225"
  },
  { label: "2226 - CAÑUELAS - BUENOS AIRES", value: "2226" },
  { label: "2229 - JUAN MARIA GUTIERREZ - BUENOS AIRES", value: "2229" },
  { label: "2241 - CHASCOMUS - BUENOS AIRES", value: "2241" },
  { label: "2246 - SANTA TERESITA - BUENOS AIRES", value: "2246" },
  { label: "2252 - SAN CLEMENTE DEL TUYU - BUENOS AIRES", value: "2252" },
  { label: "2254 - PINAMAR - BUENOS AIRES", value: "2254" },
  { label: "2255 - VILLA GESELL - BUENOS AIRES", value: "2255" },
  { label: "2257 - MAR DE AJO / SAN BERNARDO - BUENOS AIRES", value: "2257" },
  { label: "2262 - NECOCHEA - BUENOS AIRES", value: "2262" },
  { label: "2284 - OLAVARRIA - BUENOS AIRES", value: "2284" },
  { label: "2291 - MIRAMAR - BUENOS AIRES", value: "2291" },
  { label: "2317 - 12 DE OCTUBRE - BUENOS AIRES", value: "2317" },
  {
    label: "2320 - JOSE C. PAZ / TORTUGUITAS / DEL VISO - BUENOS AIRES",
    value: "2320"
  },
  { label: "2345 - 25 DE MAYO - BUENOS AIRES", value: "2345" },
  { label: "2346 - CHIVILCOY - BUENOS AIRES", value: "2346" },
  { label: "2396 - PEHUAJO - BUENOS AIRES", value: "2396" },
  { label: "2477 - PERGAMINO - BUENOS AIRES", value: "2477" },
  { label: "2622 - TUNUYAN - MENDOZA", value: "2622" },
  { label: "2901 - USHUAIA - TIERRA DEL FUEGO", value: "2901" },
  { label: "2902 - EL CALAFATE - SANTA CRUZ", value: "2902" },
  { label: "2921 - MONTE HERMOSO - BUENOS AIRES", value: "2921" },
  { label: "2924 - SAN MIGUEL ARCANGEL - BUENOS AIRES", value: "2924" },
  { label: "2925 - GENERAL SAN MARTIN - BUENOS AIRES", value: "2925" },
  { label: "2934 - BALNEARIO LAS GRUTAS - RIO NEGRO", value: "2934" },
  { label: "2945 - ESQUEL - CHUBUT", value: "2945" },
  { label: "2964 - RIO GRANDE - TIERRA DEL FUEGO", value: "2964" },
  { label: "2966 - RIO GALLEGOS - SANTA CRUZ", value: "2966" },
  {
    label: "2972 - SAN MARTIN DE LOS ANDES / JUNIN DE LOS ANDES - NEUQUEN",
    value: "2972"
  },
  { label: "2983 - TRES ARROYOS - BUENOS AIRES", value: "2983" },
  { label: "3327 - BENAVIDEZ - BUENOS AIRES", value: "3327" },
  { label: "3329 - BARADERO - BUENOS AIRES", value: "3329" },
  { label: "3401 - PIAMONTE - SANTA FE", value: "3401" },
  { label: "3442 - CONCEPCION DEL URUGUAY - ENTRE RIOS", value: "3442" },
  { label: "3444 - GUALEGUAY - ENTRE RIOS", value: "3444" },
  { label: "3446 - GUALEGUAYCHU - ENTRE RIOS", value: "3446" },
  { label: "3447 - VILLA ELISA - ENTRE RIOS", value: "3447" },
  { label: "3456 - FEDERACION - ENTRE RIOS", value: "3456" },
  { label: "3462 - VENADO TUERTO - SANTA FE", value: "3462" },
  { label: "3487 - ZARATE - BUENOS AIRES", value: "3487" },
  { label: "3489 - CAMPANA - BUENOS AIRES", value: "3489" },
  { label: "3521 - AVELLANEDA - CORDOBA", value: "3521" },
  { label: "3541 - COSQUIN / VILLA CARLOS PAZ - CORDOBA", value: "3541" },
  { label: "3543 - RIO CEBALLOS - CORDOBA", value: "3543" },
  { label: "3544 - MINA CLAVERO - CORDOBA", value: "3544" },
  { label: "3546 - VILLA GENERAL BELGRANO - CORDOBA", value: "3546" },
  { label: "3548 - CAPILLA DEL MONTE - CORDOBA", value: "3548" },
  { label: "3718 - CLORINDA - FORMOSA", value: "3718" },
  { label: "3755 - OBERA - MISIONES", value: "3755" },
  { label: "3757 - PUERTO IGUAZU - MISIONES", value: "3757" },
  { label: "3777 - 9 DE JULIO - CORRIENTES", value: "3777" },
  { label: "3786 - ITUZAINGO - CORRIENTES", value: "3786" },
  { label: "3868 - ANIMAMA - SALTA", value: "3868" },
  { label: "3873 - SALVADOR MAZZA - SALTA", value: "3873" }
];

const tipoContribuyentes = [
  {
    value: "1",
    label: "Convenio local"
  },
  {
    value: "2",
    label: "Convenio multilateral"
  }
];

const conocimientos = [
  {
    value: "01",
    label: "Radio"
  },
  {
    value: "02",
    label: "Televisión"
  }
];

export {
  byValue,
  tiposDocumento,
  estadosCiviles,
  provincias,
  situacionesLaborales,
  actividades,
  ocupaciones,
  ingresosNetos,
  sucursales,
  franjasHorarias,
  nacionalidades,
  codigosAreaPopulares,
  tipoContribuyentes,
  conocimientos
};
